module.exports = __webpack_public_path__ + "img/moisturejel_ecoset.8cd30637.jpg";